<!--
    Headline report content
-->
<template>
  <v-layout justify-space-between wrap class="pa-0 encode">
    <v-flex md7 xs10>
      <div class="encode display-1 font-weight-black pb-2">Cyclone Resilience Level</div>
    </v-flex>
    <v-flex md5 xs0></v-flex>
    <v-flex md7 xs12 class="headline pb-1">
      Your overall resilience level is
      <span
        class="headline font-weight-black"
      >{{formattedTotalScore}}</span>
    </v-flex>
    <v-flex md7 sm9 xs12 class="pb-0 subheading">
      <v-flex xl6 lg8 md9 sm10 xs12 class="pt-0 pb-2">
        <div class="main-chart text-justify-center">
          <vue-c3 :handler="chartHandler"></vue-c3>
        </div>
      </v-flex>
      <p>You can significantly improve your resilience by following the tips below. For detailed scores see below.</p>
    </v-flex>
    <v-flex xs12 sm3 md5 pl-0 ml-0 hidden-xs-only text-justify-center>
      <div class="text-xs-center">
        <table class="legend text-xs-center">
          <tbody>
            <tr>
              <td class="very-low" nowrap>1 - 2</td>
              <td>Very low</td>
            </tr>
            <tr>
              <td class="low" nowrap>2 - 3</td>
              <td>Low</td>
            </tr>
            <tr>
              <td class="high" nowrap>3 - 4</td>
              <td>High</td>
            </tr>
            <tr>
              <td class="excellent">4+</td>
              <td>Excellent</td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-flex>
    <v-flex
      xs12
      sm3
      md5
      pl-0
      ml-0
      text-xs-center
      justify-center
      text-justify-center
      hidden-sm-and-up
    >
      <div class="text-xs-center">
        <table class="legend text-justify-center" width="100%">
          <tbody>
            <tr>
              <td colspan="4">Scores</td>
            </tr>
            <tr>
              <td width="25%" class="very-low" nowrap>1 - 2</td>
              <td width="25%" class="low" nowrap>2 - 3</td>
              <td width="25%" class="high" nowrap>3 - 4</td>
              <td width="25%" class="excellent">4+</td>
            </tr>
            <tr>
              <td>Very low</td>
              <td>Low</td>
              <td>High</td>
              <td>Excellent</td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-flex>
    <v-flex sm12 text-xs-center text-sm-center justify-xs-center row>
      <div class="text-xs-center">
        <v-btn
          class="mt-2 blue-text yellow-background"
          dark
          large
          round
          @click="requestDownload($event.target)"
        >Download</v-btn>
        <v-btn v-if=hasContinue
          class="mt-2 blue-text yellow-background"
          dark
          large
          round
          @click="onContinue"
        >Continue</v-btn>
      </div>
    </v-flex>
  </v-layout>
</template>

<style>
table.legend {
  text-align: center;
}
.legend td {
  text-align: center;
}
.very-low {
  background-color: #ff0000;
}
.low {
  background-color: #f97600;
}
.high {
  background-color: #f6c600;
}
.excellent {
  background-color: #60b044;
}
</style>


<script>
import Vue from "vue";
import VueC3 from "vue-c3";
import { formatNumber } from "../utils/std.js";
import { ScoreCalculator } from "../model/reportBuilder.js";

export default {
  name: "ReportStart",
  components: {
    VueC3
  },
  props: {
    totalScore: Number
  },
  data: () => ({
    // Chart handler
    chartHandler: new Vue()
  }),
  methods: {
    // eslint-disable-next-line no-unused-vars
    requestDownload(target) {
      //console.log('Emitting...')
      this.$emit("requestDownload");
    },
    onContinue() {
      // Continue to returnUrl
      window.location.href = this.$store.state.returnUrl
    }
  },
  computed: {
    formattedTotalScore() {
      return formatNumber(this.totalScore, 1);
    },
    shouldTrace() {
      return !!this.$route.query.trace;
    },
    opinion() {
      return new ScoreCalculator().getOpinionForScore(this.totalScore);
    },
    hasContinue() {
      return this.$store.state.returnUrl != null
    },
  },
  mounted() {
    // For details see https://c3js.org/samples/chart_gauge.html
    // See also https://stackoverflow.com/questions/33109596/can-the-default-arc-color-be-set-in-a-c3-js-gauge
    // Label color: https://github.com/c3js/c3/issues/1744 (Note that thhis can't be scoped within the component)
    const options = {
      data: {
        columns: [["Total resilience", this.totalScore]],
        type: "gauge"
      },
      tooltip: {
        show: false
      },
      gauge: {
        min: 0,
        max: 5,
        units: " / 5",
        label: {
          // eslint-disable-next-line no-unused-vars
          format: function(value, ratio) {
            return formatNumber(value, 1);
          },
          show: false // to turn off the min/max labels.
        }
      },
      color: {
        pattern: ["#FF0000", "#F97600", "#F6C600", "#60B044"], // the three color levels for the percentage values.
        threshold: {
          values: [1, 3, 4, 4.5]
        }
      },
      size: {
        height: 180
      }
    };
    this.chartHandler.$emit("init", options);
  }
};
</script>
